module.exports = __webpack_public_path__ + "img/3c199120c1604697927a92118bfe81d6.b704cb3c.png";